import { createClient } from '@supabase/supabase-js'

/**
 * The one Supabase client.
 *
 * The publishable key is embedded in the JavaScript and readable by anyone who
 * opens the console. That is by design and it is only safe because row-level
 * security is enabled on all 14 tables — the key identifies the project, the
 * policies decide what the signed-in user may touch. If a policy is ever
 * dropped, this key becomes a hole. See supabase/tests/rls_test.sql.
 */

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

if (!url || !key) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY. Copy .env.example to .env.local.',
  )
}

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // No session in the URL: we never use magic links, so there is nothing to
    // parse out of the address bar. See docs/DECISIONS.md.
    detectSessionInUrl: false,
  },
})
